const POINTS_OF_SALE_PATH = "/company/:companyOid/pointOfSale/";

angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(POINTS_OF_SALE_PATH, {
        templateUrl: 'assets/pointOfSale/index.html',
        controller: 'PointsOfSaleController',
        title: 'pointOfSale.TITLE',
        sidebar: 'company'
    });
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/routes/pointofsale_route.js
// module id = 818
// module chunks = 3